import { routes as graduations } from './graduations'
import { routes as specializations } from './specializations'

export default [
  ...graduations,
  ...specializations
]



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/routes.js